import HealthcareBanner from './HealthcareBanner'
import HealthcareExpertise from './HealthcareExpertise'
import { lazy, Suspense } from 'react'

const HealthcareChallenges = lazy(() => import("./HealthcareChallenges"));
const HealthPartner = lazy(() => import("./HealthPartner"));
const PatientSupport = lazy(() => import("./PatientSupport"));
const HealthIndustries = lazy(() => import("./HealthIndustries"));
const HealthTech = lazy(() => import("./HealthTech"));
const HealthWorkflow = lazy(() => import("./HealthWorkflow"));
const ShuttleAppreciation = lazy(() => import("../shuttle_software/ShuttleAppreciation"));
const ShuttleItNeed = lazy(() => import("../shuttle_software/ShuttleItNeed"));
const IndustryPricing = lazy(() => import("../industries/IndustryPricing"));
const TaxiFaq = lazy(() => import("../taxiDispatchSoftware/TaxiFaq"));

const faqData = [
  {
    id: "0",
    question: "01. Why choose Mobility Infotech for custom healthcare software development services?",
    answer: "Mobility Infotech delivers HIPAA-compliant, scalable, and secure custom healthcare software solutions tailored to meet the unique needs of healthcare providers.",
  },
  {
    id: "1",
    question: "02. What is a software development company?",
    answer: "A software development company specializes in creating, designing, and maintaining custom software applications to meet specific business needs.ccusantium voluptatum, est tempore amet neque id magni quae quod, non vitae.",
  },
  {
    id: "2",
    question: "03. Why choose an AI-powered software development company?",
    answer: "AI-powered software development companies leverage advanced technologies to create smarter, more efficient applications that improve user experience and business processes.",
  },
  {
    id: "3",
    question: "04. How long does it take to develop a healthcare software solution?",
    answer: "The development time for a healthcare software solution varies depending on complexity, but typically ranges from a few months to a year for full deployment.",
  },
  {
    id: "4",
    question: "05. What do healthcare software development companies do?",
    answer: "Healthcare software development companies build and maintain specialized software solutions like EHRs, patient management systems, and telemedicine platforms for healthcare organizations.",
  },
  {
    id: "5",
    question: "06. What types of custom healthcare software development solutions are available?",
    answer: "Custom healthcare solutions include EHR/EMR systems, telemedicine apps, healthcare mobile apps, patient engagement portals, and clinical management software.",
  },
  {
    id: "6",
    question:
      "07. Can the implemented custom healthcare software be modified or expanded after its deployment?",
    answer: "Yes, custom healthcare software can be modified or expanded after deployment to accommodate new features, compliance updates, or scalability needs.",
  },
  {
    id: "7",
    question: "08. What do healthcare software development companies do?",
    answer: "Healthcare software development companies design, develop, and implement custom software solutions that help healthcare organizations improve operations, enhance patient care, and ensure regulatory compliance.",
  },
];

export default function HealthCare() {
  return (
    <>
      <HealthcareBanner />
      <HealthcareExpertise />

      <Suspense fallback={null}>
        <HealthcareChallenges />
        <HealthPartner />
        <PatientSupport />
        <HealthIndustries />
        <HealthTech />
        <HealthWorkflow />
        <IndustryPricing />
        <ShuttleAppreciation />
        <ShuttleItNeed />
        <TaxiFaq faqData={faqData} />
      </Suspense>
    </>
  )
}
